import React, { useEffect, useState } from "react";
import { Button, Menu, MenuButton, MenuList, MenuItem, Image, Box, useTheme, useColorModeValue, Flex, Text, Skeleton, Icon } from "@chakra-ui/react";
import { ChevronDownIcon, CheckIcon } from "@chakra-ui/icons";
import { useSupplierRetailer } from "../wrappers/SupplierRetailerContext";
// import { getDownloadURL, ref } from "firebase/storage";
// import { storage } from "../tools/firebase";

const SupplierNavigation = () => {
  const theme = useTheme();
  const { selectedSupplier, setSelectedSupplier, user_supplier_access } = useSupplierRetailer();
  const [logos, setLogos] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Color mode values
  const buttonBg = useColorModeValue("white", "gray.800");
  const buttonHoverBg = useColorModeValue(theme.colors.secondary1, "gray.700");
  const buttonColor = useColorModeValue("gray.800", "white");
  const buttonHoverColor = useColorModeValue("black", "white");
  const menuBg = useColorModeValue("white", "gray.800");
  const menuItemHoverBg = useColorModeValue(theme.colors.secondary2, "gray.700");
  const menuItemColor = useColorModeValue("gray.800", "white");
  const menuItemHoverColor = useColorModeValue("white", "white");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const handleSupplierChange = (supplier) => {
    setSelectedSupplier(supplier);
  };

  /*
  useEffect(() => {
    const fetchLogos = async () => {
      setIsLoading(true);
      const logoUrls = {};
      for (const supplier of user_supplier_access) {
        const logoRef = ref(storage, `logos/${supplier.value}.jpg`);
        try {
          const url = await getDownloadURL(logoRef);
          logoUrls[supplier.value] = url;
        } catch (error) {
          console.error("Error fetching logo:", error);
          // Use default logo if there is an error fetching the supplier logo
          const defaultLogoRef = ref(storage, `logos/blank.jpg`);
          try {
            const defaultUrl = await getDownloadURL(defaultLogoRef);
            logoUrls[supplier.value] = defaultUrl;
          } catch (defaultError) {
            console.error("Error fetching default logo:", defaultError);
          }
        }
      }
      setLogos(logoUrls);
      setIsLoading(false);
    };

    fetchLogos();
  }, [user_supplier_access]);
*/

  useEffect(() => {
    setIsLoading(true);
    const logoUrls = {};
    user_supplier_access.forEach(({ value }) => {
      const ext = value === 'DEMO' ? 'png' : 'jpg';
      logoUrls[value] = `/${value}.${ext}`;
    });
    setLogos(logoUrls);
    setIsLoading(false);
  }, [user_supplier_access]);

  return (
    <Box display="flex" alignItems="center" m={1} width="calc(100% - 8px)" mx="4px" position="relative">
      <Menu
        closeOnSelect={true}
        placement="bottom" // Control dropdown placement
        strategy="fixed" // Use fixed positioning strategy
        offset={[0, 4]} // Add some offset from the button
        gutter={0} // Control the space between the button and the menu
        isLazy // Only render menu items when the menu is open
      >
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          bg={buttonBg}
          _hover={{
            bg: buttonHoverBg,
            color: buttonHoverColor,
            transform: "translateY(-2px)",
            boxShadow: "md",
          }}
          _active={{
            bg: buttonHoverBg,
            transform: "translateY(0)",
          }}
          color={buttonColor}
          maxWidth="100%"
          minWidth="100%"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          px={3}
          py={2}
          justifyContent="space-between"
          borderRadius="md"
          boxShadow="sm"
          borderWidth="1px"
          borderColor={borderColor}
          transition="all 0.3s ease"
        >
          {isLoading ? (
            <Flex align="center">
              <Skeleton height="2rem" width="2rem" borderRadius="full" mr={3} />
              <Skeleton height="20px" width="150px" />
            </Flex>
          ) : (
            <Flex align="center">
              {logos[selectedSupplier] && (
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src={logos[selectedSupplier] || "/BLANK.jpg"}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "/blank.jpg";
                  }}
                  alt={selectedSupplier}
                  mr={3}
                  border="1px solid"
                  borderColor={borderColor}
                />
              )}
              <Text fontWeight="medium">{selectedSupplier}</Text>
            </Flex>
          )}
        </MenuButton>
        <MenuList
          bg={menuBg}
          color={menuItemColor}
          width="auto"
          maxWidth="100%"
          maxHeight="500px"
          overflowY="scroll"
          boxShadow="lg"
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="md"
          p={1}
          zIndex={1500}
          css={{
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(0, 0, 0, 0.2)",
              borderRadius: "24px",
            },
          }}
        >
          {user_supplier_access.map((supplier) => (
            <MenuItem
              key={supplier.value}
              onClick={() => handleSupplierChange(supplier.value)}
              bg={selectedSupplier === supplier.value ? menuItemHoverBg : "transparent"}
              _hover={{
                bg: menuItemHoverBg,
                color: menuItemHoverColor,
              }}
              color={selectedSupplier === supplier.value ? menuItemHoverColor : menuItemColor}
              maxWidth="100%"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              minH="48px"
              borderRadius="md"
              px={3}
              transition="all 0.2s ease"
            >
              <Flex align="center" justify="space-between" width="100%">
                <Flex align="center">
                  {logos[supplier.value] ? <Image boxSize="2rem" borderRadius="full" src={logos[supplier.value] || "/placeholder.svg"} alt={supplier.text} mr={1} border="1px solid" borderColor={borderColor} /> : <Skeleton height="2rem" width="2rem" borderRadius="full" mr={3} />}
                  <Text>{supplier.text}</Text>
                </Flex>
                {selectedSupplier === supplier.value && <Icon as={CheckIcon} color={menuItemHoverColor} />}
              </Flex>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default SupplierNavigation;
